import React from 'react';
import { FadeIn } from './FadeIn';
import { Shield, CheckCircle } from 'lucide-react';
export function ProofSection() {
  return <section className="py-24 px-4 bg-brand-dark relative overflow-hidden" data-id="element-156">
      {/* Decorative background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-orange/5 blur-[100px] rounded-full pointer-events-none" data-id="element-157" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-158">
        <FadeIn data-id="element-159">
          <div className="bg-brand-gray border border-brand-border rounded-2xl p-8 md:p-12 shadow-2xl relative" data-id="element-160">
            <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-brand-dark p-4 rounded-full border border-brand-orange" data-id="element-161">
              <Shield className="w-8 h-8 text-brand-orange" data-id="element-162" />
            </div>

            <div className="text-center mt-6" data-id="element-163">
              <h2 className="text-3xl md:text-4xl font-display font-bold text-white uppercase mb-8" data-id="element-164">
                De la Ansiedad al{' '}
                <span className="text-brand-orange" data-id="element-165">Control Total</span>
              </h2>

              <p className="text-xl md:text-2xl text-gray-300 leading-relaxed italic mb-10" data-id="element-166">
                "En los primeros 7 días de implementar este protocolo, pasarás
                de la ansiedad constante por las noticias a tener un plan de
                acción ejecutivo. Sabrás exactamente dónde está cada documento
                vital y tu 'mochila de libertad' estará lista junto a la
                puerta."
              </p>

              <div className="inline-flex items-center gap-3 px-6 py-3 bg-brand-dark rounded-full border border-brand-border" data-id="element-167">
                <CheckCircle className="text-green-500 w-5 h-5" data-id="element-168" />
                <span className="text-white font-bold uppercase tracking-wider text-sm" data-id="element-169">
                  No es paranoia, es profesionalismo familiar.
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}